module.exports = __webpack_public_path__ + "img/facebook.71325fd6.svg";